import React, { useState } from 'react';
import { Card, Input, Button, Form, Typography, Select, Divider } from 'antd';
import { useNavigate } from 'react-router-dom';
import { socket } from '../socket';
import Documentation from '../components/Documentation';

const { Title } = Typography;
const { Option } = Select;

function Home() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const createChannel = (values) => {
    setLoading(true);
    socket.emit('createChannel', {
      channelName: values.channelName,
      creatorName: values.userName,
      estimationType: values.estimationType
    });

    socket.once('channelCreated', ({ channelId }) => {
      setLoading(false);
      navigate(`/channel/${channelId}`);
    });
  };

  return (
    <div style={{ maxWidth: 1200, margin: '0 auto' }}>
      <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap' }}>
        <div style={{ flex: '1 1 400px' }}>
          <Documentation />
        </div>
        
        <Card style={{ flex: '0 1 400px' }}>
          <Title level={2}>Create Scrum Poker Session</Title>
          <Form onFinish={createChannel} layout="vertical">
            <Form.Item
              name="channelName"
              label="Session Name"
              rules={[{ required: true, message: 'Please enter a session name' }]}
            >
              <Input placeholder="My Scrum Poker Session" />
            </Form.Item>
            <Form.Item
              name="userName"
              label="Your Name"
              rules={[{ required: true, message: 'Please enter your name' }]}
            >
              <Input placeholder="John Doe" />
            </Form.Item>
            <Form.Item
              name="estimationType"
              label="Estimation Type"
              initialValue="fibonacci"
              rules={[{ required: true }]}
            >
              <Select>
                <Option value="fibonacci">Fibonacci (1, 2, 3, 5, 8, 13, 21)</Option>
                <Option value="tShirt">T-Shirt Sizes (XS, S, M, L, XL, XXL)</Option>
                <Option value="linear">Linear (1-8)</Option>
                <Option value="hours">Hours (0.5, 1, 2, 4, 6, 8, 12, 16)</Option>
              </Select>
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={loading} block>
                Create Session
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </div>
  );
}

export default Home; 